import Joi from "joi";

export const loginSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      email: null,
      password: null,
    },
    schema: Joi.object({
      email: Joi.string()
        .email({ tlds: { allow: false } })
        .required()
        .messages({
          "string.empty": joiMessage.common.required,
          "string.base": joiMessage.login.email.case1,
          "string.email": joiMessage.login.email.case1,
        }),
      password: Joi.string()
        .required()
        .regex(/^(?=.*\d)(?=.*[a-z]).{8,}$/)
        .min(8)
        .max(40)
        .messages({
          "string.empty": joiMessage.common.required,
          "string.base": joiMessage.login.password.case1,
          "string.pattern.base": joiMessage.login.password.case2,
          "string.min": joiMessage.login.password.min,
          "string.max": joiMessage.login.password.max,
        }),
    }),
    explicitCheck: {
      email: false,
      password: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};
